import react from "react";

function Header() {
    return (
        <header className="header">
            <h1 className="header-title">My Profile Card</h1>
        </header>
    );
}

export default Header;